<!-- MOLECULE: AboutExtension.vue -->
<!-- App-bar tab-strip extension rendered when the user is on the About page. -->

<script setup lang="ts">
//
// Composables
//

// About Page
const { activeTab, tabs } = useAboutPage();
</script>

<template>
  <div class="d-flex align-center w-100">
    <v-tabs v-model="activeTab" color="white" class="pt-4">
      <v-tab
        v-for="tab in tabs"
        :key="tab.value"
        :value="tab.value"
        class="text-white"
        rounded="none"
        density="compact"
        height="30"
      >
        <v-icon :icon="tab.icon" size="small" class="mr-2" />
        {{ tab.name }}
      </v-tab>
    </v-tabs>
  </div>
</template>
